module.exports = __webpack_public_path__ + "img/fondoServicios.1864bcd0.svg";